import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

export const SDKSection = () => {
    return (
        <div id="sdk">
            <h1 className="blue">SDKs</h1>
            <section className="narrow">
                <p>Check out our github page: <a href={`https://github.com/Tenor-Inc`}>{`https://github.com/Tenor-Inc`}</a></p>
            </section>
        </div>
    );
};
